function functionParser(node, fn, params) {
  if (!fn) throw new Error(`function name is undefined`)
  switch(fn) {
    case 'waitlist':
      return waitList(node, params)
    case 'scroll':
      return scroll(node, params)
    case 'dismissModal' :
      return dismissModal(node, params)
    default :
      throw new Error(`function ${fn} has no dedicated handler`)
  }
}

function dismissModal(node, params) {
  node.addEventListener('click', evt => {

    if (window.parent === window) {
      return false // CMS is not opened in a popup, don't care
    }

    window.parent.postMessage({ event : 'dismiss'}, '*')

  }, { once : true })
}

function waitList(node, params) {
  node.addEventListener('click', handler)

  created(node);

  async function handler(event) {
    event.preventDefault()
    event.stopPropagation()

    let existed = false;
    let success = false;
    //get params again in case it is changed after init
    let waitlistEl = event.target.parentNode
    if (waitlistEl.tagName !== 'A' && !waitlistEl.hash.startsWith('#fn:waitlist:')) {
      waitlistEl = document.querySelector('a[href^="#fn:waitlist:"]')
    }
    let [, functionName, ...params] = waitlistEl.getAttribute('href').split(':')

    let [itemOption, selector, callback, email, ...extraData ] = params
    if (!itemOption) return

    // put remain values to extra
    let extra = {};
    let sendWaitlistEmail = true;
    if (extraData.length > 0) {
      for (i = 0; i < extraData.length; i++) {
        if (i % 2 == 0 && i < extraData.length) {
          if (extraData[i] === 'send_waitlist_email') {
            sendWaitlistEmail = extraData[i + 1] === 'true';
          } else {
            extra[extraData[i]] = extraData[i + 1];
          }
        }
      }
    }

    // Getting extra field data from documents
    const extraDataSelector = document.querySelectorAll(`[data-waitlist-extra="${itemOption}"]`)
    Array.from(extraDataSelector).map((x, idx) => {
      const extraFieldKey = String(x.dataset.extraField) || `extra-data-${idx}`
      extra[extraFieldKey] = String(x.value) || ''
    })

    if(!!email){
      while (!validateEmail(email)) {
        email = prompt(__('Please enter your email'), email || '')
      }
    }else{
      try {
        // const signupPayload = {
        //   'fn': 'subscribeItemOption',
        //   'id': itemOption,
        //   'v': 2,
        //   'fb_event_id': Server.fbEventId ? Server.fbEventId : null
        // }
        // if (Object.keys(extra).length > 0) {
        //   signupPayload.subscriber_data = JSON.stringify(extra)
        // }

        // await Util.lazyLogin({ signUpTitle : 'Sign up to get on the waitlist', signUpButtonText : 'Sign up' }, false, 'landing', '', true, '', signupPayload)
        await Util.lazyLogin({ signUpTitle : 'Sign up to get on the waitlist', signUpButtonText : 'Sign up' })
      } catch(e) {
        // user abort
        window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'user abort' })
        return false
      }

      try {
        let userInfo = await fetch(`/controllers/User.php?fn=getUserInfo`, {
            method : 'GET',
            credentials : 'same-origin'
          })
          .then(res => res.json())
          .then(data => {
            if (typeof data !== 'object') {
              // no user info
              window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'no user info' })
              return false
            }

            if (!data.email) {
              do {
                email = prompt(__('Please enter your email'), email || '')
              } while (!validateEmail(email))
            } else {
              email = data.email
            }
          })
      } catch(e) {
        // cannot get user info
        window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'cannot get user info' })
        return false
      }
    }

    try {
      if(email === null){
        window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'failed to subscribe' })
        return false
      }

      if (window.nativeInterface && typeof window.nativeInterface.getMessagingToken === 'function') {
        let fcmToken = await nativeInterface.getMessagingToken().catch(err => { console.error(err); return null; });
        if (fcmToken) {
          extra.fcmToken = fcmToken;
        }
      }

      let body = new FormData()
      body.append('fn', 'subscribeItemOption')
      body.append('email', email)
      body.append('id', itemOption)
      body.append('v', 2)
      body.append('fb_event_id', Server.fbEventId ? Server.fbEventId : null);
      body.append('send_waitlist_email', sendWaitlistEmail.toString());

      if( Object.keys(extra).length > 0 ){
        body.append('subscriber_data',JSON.stringify(extra));
      }

      let response = await fetch(`/controllers/ItemOption.php`, {
          method : 'POST',
          credentials : 'same-origin',
          body
        })
        .then(res => res.json())
        .then(res => {
          if (res.status == 'success') {
            existed = res.existed;
            success = true;

            const CMSJoinedWaitListEvent = new CustomEvent('#fn:waitlist:' + itemOption, {
              detail: res
            });
            window.dispatchEvent(CMSJoinedWaitListEvent)

            if (typeof fbq != 'undefined' && !res.existed) {
              let dummyArtworkId = '6292265'
              fbq('trackCustom', 'SubscribeToWaitlist', {content_type: 'product', content_ids: ConstantsManager.PRODUCT_SKU_CODE_PREFIX + '-' + dummyArtworkId + '-' + itemOption}, Server && Server.fbEventId ? {eventID: Server.fbEventId} : null)
            }

            if (typeof _gaq != 'undefined' && !res.existed) {
              let dummyArtworkId = '6292265'
              _gaq.push(['_trackEvent', 'Waitlist', 'Subscribed', ConstantsManager.PRODUCT_SKU_CODE_PREFIX + '-' + dummyArtworkId + '-' + itemOption, 0, true]);
            }

            if (typeof dataLayer != 'undefined' && !res.existed) {
              let dummyArtworkId = '6292265'
              let product = {
                'name' : res.itemOptionName ? res.itemOptionName : '',
                'content_ids': ConstantsManager.PRODUCT_SKU_CODE_PREFIX + '-' + dummyArtworkId + '-' + itemOption,
              }
              let category = ''
              if (res.itemOptionTags && res.itemOptionTags[itemOption] && res.itemOptionTags[itemOption]['item_category']) {
                category = res.itemOptionTags[itemOption]['item_category'][0]
              }
              if (category) {
                product.category = category
              }
              dataLayer.push({
                'event': 'SubscribeToWaitlist',
                'product': product
              });
            }

            if (window.nativeInterface && window.nativeInterface.subscribeToTopic) {
              window.nativeInterface.subscribeToTopic(`${itemOption}`);
            }

            if(window.nativeInterface && window.nativeInterface.requestReview){
              window.nativeInterface.requestReview()
            }

          } else {
            console.error(`failed to subscribe`)
            window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'failed to subscribe' })
            return false
          }
        })
    } catch(e) {
      // cannot subscribe
      window.vueEventHub && window.vueEventHub.$emit('waitlist-failed', { 'itemOption': itemOption, 'message': 'cannot subscribe' })
      return false
    }

    visualUpdate(node)

    if (!!callback) {
      let [fn, ...chains] = callback.split('.')
      let resolvedCallback = window[fn]
      resolvedCallback = chains.reduce((p, n) => {
        if (!!p[n]) {
          return p[n]
        } else {
          throw new Error(`invalid callback: ${fn}`)
        }
      }, resolvedCallback)
      if (typeof resolvedCallback === 'function') {
        resolvedCallback(itemOption, selector, existed, success)
      } else {
        console.error(`invalid callback: ${fn}`)
      }
    } else {
      window.showSuccessMessage && showSuccessMessage(__('Subscribed Successfully'))
    }
    window.vueEventHub && window.vueEventHub.$emit('waitlist-success', { 'itemOption': itemOption, 'email': email })

    return false

  }

  function visualUpdate(node){
    let href = node.getAttribute('href')
    let [, functionName, ...params] = href.split(':')
    let [itemOption, selector, callback, email, ...extraData ] = params

    // visual update after subscription
    let el = document.querySelectorAll(`[href="${href}"]`)
    if (!!selector) {
      el = document.querySelectorAll(selector)
    }

    if (!!el) {
      Array.from(el).forEach(el => {
        // CMSCustomButton Subscribed ItemOption Behavior
        if (el.classList.contains('cms-custom-button') && Boolean(el.querySelector('.custom-button-container'))) {
          el.classList.add('subscribed')
          el.querySelector('.custom-button-container').classList.add('disabled')
        }
        // original
        else {
          let button = el.querySelector("button");
          button.innerText = button.dataset.subscribedText ? button.dataset.subscribedText : __("Waitlisted");
          button.setAttribute('disabled','disabled');
          el.classList.add('subscribed')
        }
      })

    }
  }

  async function created(node){
    let href = node.getAttribute('href')
    let [, functionName, ...params] = href.split(':')
    let [itemOption, selector, callback, email, ...extraData ] = params

    let body = new FormData()
    body.append('fn', 'checkItemOptionSubscribed')
    body.append('item_option', itemOption)

    let response = await fetch(`/controllers/ItemOption.php`, {
        method : 'POST',
        credentials : 'same-origin',
        body
      })
      .then(res => res.json())
      .then(res => {
        if(res.subscribed){
          visualUpdate(node);
          const CMSJoinedWaitListEvent = new CustomEvent('#fn:waitlist:' + itemOption, {
            detail: res
          });
          window.dispatchEvent(CMSJoinedWaitListEvent)
        }
      })
  }
}


function scroll(node, params) {

  node.addEventListener('click', handler)

  function handler(event) {

    event.preventDefault()
    event.stopPropagation()

    let [target] = params

    if (target === '_top') {
      document.documentElement.scrollTo({ top : 0, behavior : 'smooth' })
    } else {
      let el = document.querySelector(target)
      if (!!el) {
        el.scrollIntoView({ behavior : 'smooth' })
      } else {
        console.warn(`scrolling target selector "${target}" returns no element`)
      }
    }

    return false

  }

}

module.exports = functionParser



// WEBPACK FOOTER //
// ./src/functionParser.js